import React from 'react';
import { CtaButton } from '../CtaButton';
import { tools } from '../../data/landing';
export function Tools() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="tools-title" data-id="element-251" data-mp="2mkfmyv626irs">
      <div className="mx-auto max-w-3xl px-5" data-id="element-252" data-mp="2hj9u8xceevi9">
        <h2 id="tools-title" className="text-balance text-center font-display text-[1.9rem] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-253" data-mp="2hm4eanri2eb5">
          Plus, You’ll Get <span className="text-brand-600" data-id="element-254" data-mp="28ko70ovzesb5">Immediate Access</span> To:
        </h2>

        <ul className="mt-10 divide-y divide-navy-900/10 border-y border-navy-900/10" data-id="element-255" data-mp="23r21rhs5dqpd">
          {tools.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 py-5" data-id="element-256" data-mp="1tuqmcix9gkqp">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand-50" data-id="element-257" data-mp="1tw1n09vetcdl">
                <Icon className="h-6 w-6 text-brand-600" aria-hidden="true" data-id="element-258" data-mp="1puya9w8nrwgl" />
              </span>
              <div data-id="element-259" data-mp="1kuk98y5h5ms2">
                <h3 className="text-lg font-extrabold text-navy-900" data-id="element-260" data-mp="159g6ho0av5ip">{title}</h3>
                <p className="mt-1 text-base leading-relaxed text-navy-900/75" data-id="element-261" data-mp="157d5k8xlzrz7">{text}</p>
              </div>
            </li>)}
        </ul>

        <blockquote className="mt-10 rounded-3xl bg-navy-900 p-6 text-center sm:p-8" data-id="element-262" data-mp="w9kpv3nz6iba">
          <p className="text-lg text-white/75" data-id="element-263" data-mp="109v6da9e8r4e">Your goal isn’t to memorize another textbook.</p>
          <p className="mt-2 font-display text-2xl font-black leading-snug text-white sm:text-3xl" data-id="element-264" data-mp="1o07eal4n2nuz">
            Your goal is to have a clinical playbook you can return to{' '}
            <em className="text-brand-400" data-id="element-265" data-mp="1swoa81i2y6im">whenever you need structure.</em>
          </p>
        </blockquote>

        <CtaButton className="mt-12" label="Get access to the complete playbook" data-id="element-266" data-mp="1jyca98vbpwdi" />
      </div>
    </section>;
}